import { Component, OnInit, Optional } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.page.html',
  styleUrls: ['./popover.page.scss'],
  standalone: false
})
export class PopoverPage implements OnInit {
  popover: any;

  constructor(private auth: AuthService, private router: Router) {}

  ngOnInit() {}

  async logout() {
    localStorage.clear();
    await this.auth.logout();
    await this.popover.dismiss();
    await this.router.navigate(['auth/login'],{ replaceUrl: true });
  }
}
